module.exports = __webpack_public_path__ + "static/media/location-maps-letter-g-arrow-serr1.5ef533e3.png";